import React from 'react';
import withParams from '../modules/router-manage/withParams';
import EditPostContainer from '../templates/edit-post/EditPostContainer';

const EditPostPage = ({ params }) => (
    <EditPostContainer params={params}/>
);

export default withParams(EditPostPage);


// WEBPACK FOOTER //
// ./src/pages/EditPostPage.js